import { Button, type ButtonProps } from "@mui/material";
import { useTranslation } from "react-i18next";
import { authPrimaryButtonSx } from "../../theme/authPrimaryButtonStyles";

type AuthPrimaryButtonProps = ButtonProps & {
  loading?: boolean;
};

const AuthPrimaryButton = ({
  children,
  disableElevation = true,
  disabled,
  fullWidth = true,
  loading = false,
  variant = "contained",
  sx,
  ...props
}: AuthPrimaryButtonProps) => {
  const { t } = useTranslation();
  return (
    <Button
      disableElevation={disableElevation}
      disabled={disabled || loading}
      fullWidth={fullWidth}
      variant={variant}
      sx={[authPrimaryButtonSx, ...(Array.isArray(sx) ? sx : sx ? [sx] : [])]}
      {...props}
    >
      {loading ? (
        <>
          <span className="invisible inline-flex items-center justify-center leading-[var(--type-button-line-height)]">
            {children}
          </span>
          <span
            aria-label={t("loading")}
            className="absolute left-1/2 top-1/2 size-4 -translate-x-1/2 -translate-y-1/2 animate-spin rounded-full border-2 border-white border-t-transparent"
            role="status"
          />
        </>
      ) : (
        <span className="inline-flex items-center justify-center leading-[var(--type-button-line-height)]">
          {children}
        </span>
      )}
    </Button>
  );
};

export default AuthPrimaryButton;
